// Client calls to the Worker identity endpoints.
//
// `bind` pairs the anonymous IndexedDB id with the FingerprintJS visitorId and
// receives a stable device id; the Worker also sets the authoritative
// HttpOnly cookie. `forget` tombstones the device server-side (SLA documented
// in consent/policy.md) — `credentials: "include"` so the cookie rides along.

import { apiUrl } from "../api/fetch";
import type { ConsentRecord } from "../consent/state";

interface BindResponse {
  device_id: string;
}

export async function bindIdentity(
  visitorId: string,
  anonymousId: string,
  consent?: ConsentRecord | null,
): Promise<string> {
  const res = await fetch(apiUrl("/api/identity/bind"), {
    method: "POST",
    headers: { "content-type": "application/json" },
    credentials: "include",
    body: JSON.stringify({
      visitorId,
      anonymous_id: anonymousId,
      consent: consent ?? null,
    }),
  });
  if (!res.ok) {
    throw new Error(`identity/bind -> ${res.status} ${res.statusText}`);
  }
  const data = (await res.json()) as BindResponse;
  if (!data.device_id) throw new Error("identity/bind: missing device_id");
  return data.device_id;
}

export async function forgetIdentity(): Promise<void> {
  const res = await fetch(apiUrl("/api/identity/forget"), {
    method: "POST",
    credentials: "include",
  });
  if (!res.ok) {
    throw new Error(`identity/forget -> ${res.status} ${res.statusText}`);
  }
}
